import { PerfilsActionTypes, PerfilState, PERILS_GET } from "domain/types/perfil/perfil";

const INITIAL_STATE: PerfilState = {
    Perfils: undefined,
}

export function PerfilReducer(state = INITIAL_STATE, action: PerfilsActionTypes): PerfilState {
    switch (action.type) {
        case PERILS_GET:
            return { ...state, Perfils: action.payload }

        default:
            return state
    }
}